import makeStyles from "@mui/styles/makeStyles";
import { ExtraBold } from "../../utils";
export const useStyles = makeStyles((theme) => ({
    dialog: {
        width: "100%",
        maxWidth: "auto",
        padding: "0 !important",
        "& .MuiPaper-root": {
            width: "100% !important",
            borderRadius: "4px",
        },
        "& .MuiDialogContent-root": {
            padding: "0px !important",
            position: 'relative'
        },
        '& .MuiDialog-container': {
            padding: (props) => props?.padding ?? '',
        }
    },
    header: {
        border: "1px solid #E4E8EE",
        fontSize: "1rem",
        fontFamily: ExtraBold,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        textTransform:"capitalize"
    },
    drawer: {
        "& .MuiDrawer-paper": {
            borderTopLeftRadius: (props) => props?.is_filter ?"0px" : "16px",
            borderTopRightRadius: (props) => props?.is_filter ?"0px" : "16px",
        },
        "& .MuiContainer-root": {
            padding: "0px",
        },
    },
    component: {
        overflow: "auto"
    }
}));